module.exports = require('./helpers/bundle-url').getBundleURL('QXyrT') + "clock.5d0174fe.svg";